export const RS_DESKTOP_FEATURE_TOGGLE_NAME = 'dailyrent_desktop.search_v2.Enabled';
